// Feeds a view's figure/ground split to the board.
//
// Mirrors `LifecycleProvider` / `NodeColoringProvider`: a paint-only channel,
// memoised on the key set alone, so changing the focused view repaints and
// never re-solves. The context + resolver live in `useBoardFocus.ts`
// (component-free); this file holds only the provider.

import { useMemo, type ReactNode } from "react";
import { BoardFocusContext, makeBoardFocus } from "./useBoardFocus.js";

export function BoardFocusProvider({
  figure,
  children,
}: {
  /** Board keys the active view marks as figure. Empty / absent ⇒ no focus at
   *  all, and the context stays null so every consumer costs nothing. */
  readonly figure?: ReadonlySet<string>;
  readonly children: ReactNode;
}) {
  const value = useMemo(() => (figure ? makeBoardFocus(figure) : null), [figure]);
  return <BoardFocusContext.Provider value={value}>{children}</BoardFocusContext.Provider>;
}
